<template>
	<div id="app" :data-version="version">
		<component :is="layout" v-bind="templateProps">
			<router-view :layout.sync="layout" @update:templateProps="handleUpdateProps" />
		</component>
	</div>
</template>

<script type="text/javascript">
import { mapActions, mapGetters } from 'vuex';

export default {
	created() {
		this.setLanguage({ lang: this.lang });
	},
	data: () => ({ version: process.env.VERSION, layout: 'div', templateProps: null }),
	computed: {
		...mapGetters({
			activeTopItem: 'menu/activeTopItem',
			activeSubmenu: 'menu/activeSubmenu',
			lang: 'lang/lang'
		})
	},
	methods: {
		...mapActions('lang', ['setLanguage']),
		handleUpdateProps(props) {
			this.templateProps = props;
		}
	}
};
</script>
